angular.module('wbDashboard').controller('FundingRolloversControllerAurea',
        ['$scope', '$uibModal', '$q', '$filter', 'User', 'Message', 'PlanService',
function ($scope, $uibModal, $q, $filter, User, Message, PlanService) {

}]);
